import React, {useState} from "react";
import {Card} from "react-bootstrap";
import {PiCaretDown, PiCaretUp, PiInfo} from "react-icons/pi";

const PURPOSE_TEXT =
    "Die Vertriebsauswertung gibt Geschäftsführung und Vertrieb eine schnelle Übersicht über Umsatz und " +
    "Bestellverhalten unserer Handelskunden. Sie zeigt je Kunde, wo er stark ist – und vor allem, was er nicht " +
    "(mehr) kauft. So ermöglicht sie die bestmögliche Beratung jedes Kunden, frühes Gegensteuern und neue " +
    "Verkaufsstrategien.";

const STORAGE_KEY = "va-purpose-box-open";

/** Liest den gemerkten Aufklappzustand - Zugriff defensiv, falls localStorage gesperrt ist (privater Modus u. Ä.). */
function readStoredOpen() {
    try {
        const stored = window.localStorage.getItem(STORAGE_KEY);
        return stored === "1";
    } catch (e) {
        return false;
    }
}

function writeStoredOpen(open) {
    try {
        window.localStorage.setItem(STORAGE_KEY, open ? "1" : "0");
    } catch (e) {
        // localStorage nicht verfügbar - der Aufklappzustand bleibt dann nur
        // für die laufende Sitzung erhalten, kein Fehlerfall.
    }
}

/**
 * Zweckkasten oben auf jeder Seite der Vertriebsauswertung (E1, wörtlicher
 * Text). Standardmäßig eingeklappt, damit er auf den datenlastigen Sichten
 * nicht dauerhaft Platz beansprucht; der Aufklappzustand wird je Browser in
 * localStorage gemerkt.
 */
export default function PurposeBox() {
    const [open, setOpen] = useState(readStoredOpen);

    const toggle = () => {
        setOpen((current) => {
            const next = !current;
            writeStoredOpen(next);
            return next;
        });
    };

    return (
        <Card className="mb-3 border-0 bg-body-secondary">
            <button
                type="button"
                className="btn btn-link text-decoration-none text-body d-flex align-items-center gap-2 w-100 text-start px-3 py-2"
                aria-expanded={open}
                onClick={toggle}
            >
                <PiInfo className="flex-shrink-0" aria-hidden="true" />
                <span className="fw-semibold small">Wozu die Vertriebsauswertung</span>
                <span className="ms-auto">
                    {open ? <PiCaretUp aria-hidden="true" /> : <PiCaretDown aria-hidden="true" />}
                </span>
            </button>
            {open && <Card.Body className="pt-0 small text-muted">{PURPOSE_TEXT}</Card.Body>}
        </Card>
    );
}
